import {
    BrowserRouter as Router,
    Switch,
    Route, Redirect,
    // Link
} from "react-router-dom";
import CreateCampaignPage from "./campaign/CreateCampaignView";
import GetCampaignPage from "./campaign/GetCampaignView";
import HomePage from "./homepage/HomePage";
import AddToCampaignView from "./campaign/AddToCampaignView";
import {Nav, Navbar} from "react-bootstrap";
import fourOFour from "./404";
import AddMetroMedia from "./campaign/AddMetroMedia";
import EditBoard from "./campaign/EditBoard/EditBoard";
import EditCampaignView from "./campaign/EditCampaign/EditCampaignView";
import React from "react";
import Axios from "axios";
import {deleteCookie, getCookie, setCookie} from "./helpers/Cookie";
import ProtectedRoute from "./ProtectedRoute";
import CampaignsView from "./campaign/CampaignsList/CampaignsView";
import CustomNavbar from "./CustomNavbar";
import AccountView from "./user/AccountView";
import {EditBoards} from "./campaign/EditBoards/EditBoards";
import {FilePage} from "./campaign/FilePage";
import FolderView from "./campaign/CampaignsList/FolderView";

export default function App() {
    if (process.env.NODE_ENV !== "development" && window.location.protocol !== 'https:') {
        //redirect to https if http
        // window.location.replace(`https:${window.location.href.substring(window.location.protocol.length)}`);
    }
    let urlSearchParams = new URLSearchParams(window.location.search);
    let token = urlSearchParams.get("t");
    if(token){
        setCookie("telos_auth",token);
        if(urlSearchParams.get("signup") === "true"){
            window.location.replace("/users/account");
        }
    }
    token = getCookie("telos_auth");
    if(token) {
        Axios.defaults.headers.common['Authorization'] = token;
        //more token handling. Fetching using happening in ProtectedRoute.js middleware
    }
    return (
        <Router>
            <div>
                {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
                <Switch>
                    {/*<Route path="/" render={() => (*/}
                    {/*    loggedIn ? (*/}
                    {/*        <Redirect to="/dashboard"/>*/}
                    {/*    ) : (*/}
                    {/*        <Redirect to="/campaign/create"/>*/}
                    {/*    )*/}
                    {/*)}/>*/}
                    <Route exact path="/" render={() => (
                        token ? (
                            <Redirect to="/campaigns"/>
                        ) : (
                            <Redirect to="/sign-in"/>
                        )
                    )}/>
                    <Route exact path="/sign-in" component={HomePage}/>
                    <Route path={"/"}>
                        <CustomNavbar/>
                        <div className={"main-content"}>
                            {/*TODO: make switch component so can get user in component will mount*/}
                            <Switch>
                                {/*Campaigns is protected, Campaign is not*/}
                                <ProtectedRoute exact path="/campaigns/create" token={token} component={CreateCampaignPage}>
                                </ProtectedRoute>
                                <ProtectedRoute exact path="/campaigns/:campaignId/edit-board" token={token} component={EditBoard}>
                                </ProtectedRoute>
                                <ProtectedRoute exact path="/campaigns/:campaignId/edit-campaign" token={token} component={EditCampaignView}>
                                </ProtectedRoute>
                                <ProtectedRoute exact path="/campaigns" token={token} component={CampaignsView}>
                                </ProtectedRoute>
                                <ProtectedRoute exact path="/campaigns/folder/:folderId" token={token} component={FolderView}>
                                </ProtectedRoute>
                                <ProtectedRoute exact path="/users/account" token={token} component={AccountView}>
                                </ProtectedRoute>
                                <Route exact path="/campaigns/:campaignId/edit-boards" component={EditBoards}>
                                </Route>
                                <Route exact path="/campaign/:campaignId/files" component={FilePage}>
                                </Route>
                                <Route exact path="/campaign/:campaignId/upload" component={AddToCampaignView}>
                                </Route>
                                <Route exact path="/campaign/:campaignId" render={
                                    (props)=>(<GetCampaignPage {...props} />)}>
                                </Route>
                                <Route exact path="/campaign/:campaignId/add-metro-media" component={AddMetroMedia}>
                                </Route>
                                <Route exact path="/logout" render={()=>{
                                    deleteCookie("telos_auth")
                                    window.location.replace("/")
                                    return <></>
                                    }
                                }>
                                </Route>
                                <Route path="/" component={fourOFour}>
                                </Route>
                            </Switch>
                        </div>
                    </Route>
                </Switch>
            </div>
        </Router>
    );
}
